<template>
  <DialogTemplate
    :contentStretch="true"
    style="max-width: unset; background: transparent; --dialog-content-overflow: hidden"
    :contentStyle="'margin:0!important;padding:0!important;'"
  >
    <!-- {{ board }} -->
    <!-- {{ loading || error ? 'E0E1E2' : board }} -->
    <!-- {{ error }} -->
    <div
      v-if="!loading"
      class="f-column f-center flex-1"
    >
      <div
        v-if="!error"
        class="f-center flex-1 pt-10 pb-6 w-100"
        style="background: var(--clr-black-0-1)"
      >
        <CardRow
          :cards="loading || error ? 'E0E1E2' : board"
          size="large"
          cardStyle="
          --height: clamp(1px, 8.125rem, 25vw);
          --value-size-increase: 3.5;
          margin: 0 0.25rem;
          --gwiz-logo-inline-svg: var(--gwiz-logo-inline-svg-darker);
        "
          :cardVisual="{
            cardTheme: 'default_big_symbol',
            cardBack: 'back_logo',
          }"
        />
      </div>
      <div
        class="pa-6 f-center w-100"
        style="backdrop-filter: blur(10px)"
        :style="`background:${
          error === 'unknown_error' ? 'rgba(245, 83, 83, 0.2)' : 'rgba(7, 110, 91, 0.2)'
        }`"
      >
        <IconAndText
          v-if="error"
          class="px-4"
          :icon="error === 'already_answered' ? 'mdi-check-all' : 'mdi-alert-circle-outline'"
          :title="
            error === 'already_answered'
              ? `You've already answered this quiz`
              : $t('messages.oops_error')
          "
          :subtitle="error === 'already_answered' ? '' : $t('messages.opps_error_sub')"
          :style="
            error === 'already_answered'
              ? '--icon-color: var(--clr-primary);--icon-title-clr: var(--clr-primary);'
              : '--icon-color: var(--clr-error);--icon-title-clr: var(--clr-error);'
          "
          style="
            flex-direction: row;
            --icon-size: 5rem;
            --icon-text-margin: 0 0 0 1.5rem;

            --icon-title-font-size: 1.5rem;
            --icon-title-align: flex-start;
            --icon-sub-clr: var(--clr-white-0);
            --icon-sub-font-size: 1.25rem;
            --icon-sub-weight: 500;
          "
        />
        <IconAndText
          v-else
          icon="mdi-check-all"
          class="px-4 text-left"
          title="Congratulations!"
          subtitle="Your answer has been submitted."
          style="
            flex-direction: row;
            --icon-size: 5rem;
            --icon-color: var(--clr-primary);
            --icon-text-margin: 0 0 0 1.5rem;
            --icon-title-clr: var(--clr-primary);
            --icon-title-font-size: 1.5rem;
            --icon-title-align: flex-start;
            --icon-sub-clr: var(--clr-white-0);
            --icon-sub-font-size: 1.25rem;
            --icon-sub-weight: 500;
          "
        />
      </div>
    </div>
    <div
      v-else
      class="f-column f-center flex-1 pa-12 gw_box"
    >
      <LoaderSpinner
        :style="`--size:4rem`"
        style="min-height: 3.5rem"
        data-tst="study_loaderspinner"
      />
    </div>
  </DialogTemplate>
</template>

<script>
import CardRow from '@/components/CardRow/CardRow'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import IconAndText from '@/components/Poker/Overlays/IconAndText'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import { deleteCookie, setCrossDomainCookie } from '@gto/helpers/cookies'

export default {
  name: 'TritonCardsConfirmDialog',
  components: {
    CardRow,
    DialogTemplate,
    IconAndText,
    LoaderSpinner,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {
      board: 'E0E1E2',
      loading: false,
      error: '',
    }
  },
  created() {
    const board = this.$route.query.tritonBoard || ''
    this.board = board

    deleteCookie('GTO_TRITON_REDIRECT')
    deleteCookie('GTO_TRITON_BOARD')
    setCrossDomainCookie('GTO_TRITON_BOARD_ANSWERED', board, 60)

    this.postAnswer(board)
  },
  mounted() {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          tritonBoard: null,
        },
      })
      .catch(() => {})
  },
  methods: {
    async postAnswer(board) {
      this.loading = true
      const result = await this.$store.dispatch('api_call', {
        method: 'POST',
        endpoint: `quizzes/answers/`,
        data: {
          quiz_id: 421, //  change id to get 200 reponse
          // quiz_id: this.isDev ? Math.floor(100 * Math.random()) : 420, //  change id to get 200 reponse
          // quiz_id: Date.now(), //  change id to get 200 reponse
          answer: board,
        },
        hasCancel: false,
      })
      if (result.error) {
        this.error = result.status === 400 ? 'already_answered' : 'unknown_error'
      }
      // this.error = 'already_answered'
      // this.error = 'unknown_error'
      this.loading = false
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'triton-confirm-dialog')
    },
  },
  computed: {
    isDev() {
      // return import.meta.env.VITE_ENV === 'production'
      // ? import.meta.env.VITE_BRANCH !== 'master' : true
      return import.meta.env.VITE_BRANCH !== 'master'
      // return import.meta.env.VITE_ENV !== 'production'
    },
  },
}
</script>

<style lang="scss" scoped>
// .triton {
// }
</style>
